export const GENERIC_ERROR = 'Ocorreu um erro. Tente novamente mais tarde';
export const GENERIC_ERROR_NOT_TRACKED = `04 - ${GENERIC_ERROR}`;
export const GENERIC_ERROR_OK_EMPTY_RESPONSE = `01 - ${GENERIC_ERROR}`;
export const GENERIC_ERROR_SIGNUP = `02 - ${GENERIC_ERROR}`;

export const getFriendlyError = (errorType: string, error: string): string => {
  const upperErrorType = (errorType ?? '').toUpperCase();
  const upperError = (error ?? '').toUpperCase();

  if (upperError === 'BAD CREDENTIALS') {
    return 'E-mail ou Senha estão inválidos.';
  } else if (
    upperErrorType === 'INVALID_GRANT' &&
    (upperError.includes('BLOQUEADO') || upperError.includes('DISABLED'))
  ) {
    return error;
  }

  return GENERIC_ERROR_NOT_TRACKED;
};
